<mat-card class="about-card">
    <mat-card-header>
      <mat-card-title>A Haunted Story</mat-card-title>
    </mat-card-header>

    <mat-card-actions>
      <a mat-button href="/about">Let's Go</a>
    </mat-card-actions>
  </mat-card>
